module.exports = {
    RECEIVE_STATION_WATERMASS: 'RECEIVE_STATION_WATERMASS',
    RECEIVE_ALL_WATERMASS: 'RECEIVE_ALL_WATERMASS',
}
